<template>
<m-pageframe
  title="Home"
>
    
</m-pageframe>
</template>

<script>
const E164 = require('@/js/E164.js');

export default {
    mounted () {

        if ( !this.$rc.$state.isSignedIn() )
        {
            this.$router.replace({
                    'name' : 'sign-in',
                })
            .catch(e=>{});

            return;
        }
        
        this.$rc.$state.clearCache();

        this.$rc.onValidateAuth(
        
            () => {
                this.afterValidateAuth();
            }
        ); 
    },

    methods: {
        afterValidateAuth() 
        {
            if ( this.$route.params.endpoint != null )
            {
                this.afterValidAuthWithActiveEndpoint();
                return;
            }

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/conversation/head/:employee_id',
            
                'params' : {
                    'employee_id': this.$rc.$state.employee_id,
                    },
            
                'on_success': (data) => {

                        if ( data.head_response_type == 'special-purpose-organization' )
                        {
                            if ( data.special_purpose == 'outshinery')
                            {
                                this.$router.push({
                                    'name': 'portal-outshinery-home',
                                    'params' : {
                                    }
                                });
                            }

                            this.$rc.alert("Special purpose organization home page unknown","The home page for this special purpose organization is unknown");
                            return;
                        }
                        
                        if ( data.head_response_type == 'home-with-endpoint')
                        {
                            this.$router.replace({
                                'name': 'home-routed',
                                'params' : {
                                    'endpoint': E164.slimEndpoint(data.endpoint),
                                    'conversation_id': 'none',
                                }
                            })
                            .catch(e=>{});

                            return;
                        }

                        if ( data.head_response_type == 'no-endpoints')
                        {
                            this.$router.replace({
                                    'name' : 'error-no-employee-endpoints',
                                })
                            .catch(e=>{});
                        }

                        if ( data.head_response_type == 'welcome-ordinary-user' || data.head_response_type == 'welcome-organization-admin')
                        {
                            this.$router.push({
                                'name': 'welcome_ordinary_user',
                                'params' : {
                                    'employee_id': this.$rc.$state.employee_id,
                                }
                            });
                        }
                    },
            
                'on_error': 'Unable to determine current home screen',
            });
        },

        afterValidAuthWithActiveEndpoint()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/conversation/head/:employee_id/:active_endpoint',
            
                'params' : {
                        'employee_id': this.$rc.$state.employee_id,
                        'active_endpoint': E164.slimEndpoint(this.$route.params.endpoint)
                    },
            
                'on_success': (data) => {

                        
                        this.$router.replace({
                            'name': 'home-routed',
                            'params' : {
                                'endpoint': E164.slimEndpoint(data.endpoint),
                                'conversation_id': 'none',
                            }
                        })
                        .catch(e=>{});

                        
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

    },


}
</script>

<style lang="scss" scoped>

</style>